import axios, { AxiosError } from 'axios';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import { ProgressSpinner } from 'primereact/progressspinner';
import { useState } from 'react';

type PropsFormUser = {
  currentStep: number;
  setCurrentStep: (value: number) => void;
  paymentMethod: string;
};

export const SignDocument = (props: PropsFormUser) => {
  const user = useSelector((state: RootState) => state.user);
  const [signLoader, setSingLoader] = useState(false);
  const [nextStepLoader, setNextStepLoader] = useState(false);


  const nextStep = () => {
    setNextStepLoader(true)
    axios
      .post(
        `${process.env.REACT_APP_API_BACKEND}/registers/${localStorage.getItem(
          'register_id'
        )}/step`,
        {
          step: props.currentStep + 1
        },
        {
          headers: {
            'Access-Control-Allow-Origin': '*',
            Authorization: `Bearer ${localStorage.getItem('token_user_latam')}`
          }
        }
      )
      .then((response: any) => {
        props.setCurrentStep(props.currentStep + 1);
      })
      .catch((error: AxiosError) => console.log('Error Aval =>', error));
  };

  const handleSigninDocument = () => {
    setSingLoader(true)
    axios
      .post(
        `${process.env.REACT_APP_API_BACKEND}/docusign/sign`,
        {
          register_id: Number(localStorage.getItem('register_id')),
          payment_method: 'Anticipado'
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token_user_latam')}`
          }
        }
      )
      .then((response: any) => {
        // console.log('Fima Documento =>', response.data);
        window.location.replace(response.data);
      })
      .catch((error: AxiosError) =>
        console.log('Error Docusign Firma =>', error)
      );
  };

  return (
    <section className="w-full max-w-6xl mx-auto ">
      <div className="mb-8">
        <h2 className="text-xl text-center md:text-2xl font-semibold text-gray-900 mb-2">
          Firma de acuerdo
        </h2>
        <p className="text-gray-600 text-sm text-center">
          Utiliza DocuSign para firmar tu acuerdo de manera segura y electrónica.
            Una vez firmado, podrás continuar con el proceso de pago.
        </p>
      </div>

      <div className="bg-white border border-gray-300 rounded-lg shadow-sm p-8 mb-6">
        <div className="flex flex-col items-center">
          <img
            src={require('../../../assets/images/img_firma.png')}
            className="w-64 md:w-80 mb-8"
            alt="firma-docusign"
          />

          {user.status === 'Contrato Firmado' && (
            <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-6 w-full max-w-md">
              <p className="text-green-700 text-center font-medium">
                ✓ Contrato firmado exitosamente
              </p>
            </div>
          )}

          <div className="flex flex-col sm:flex-row gap-4 w-full max-w-md justify-center">
            {user.status !== 'Contrato Firmado' && (
              <button
                className="btn relative inline-flex justify-center items-center min-w-[195px]"
                type="button"
                onClick={handleSigninDocument}
                disabled={signLoader}
              >
                {signLoader ? (
                  <ProgressSpinner
                    style={{ width: '25px', height: '25px' }}
                    strokeWidth="5"
                    fill="#ffffff"
                    animationDuration="1.5s"
                  />
                ) : (
                  "Firmar Documento"
                )}
              </button>
            )}

            {user.status === 'Contrato Firmado' && (
              <button
                className="btn relative inline-flex justify-center items-center min-w-[150px]"
                type="button"
                onClick={nextStep}
                disabled={nextStepLoader}
              >
                {nextStepLoader ? (
                  <ProgressSpinner
                    style={{ width: '25px', height: '25px' }}
                    strokeWidth="5"
                    fill="#ffffff"
                    animationDuration="1.5s"
                  />
                ) : (
                  "Continuar"
                )}
              </button>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};
